import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/common-icon/table-control-key.svg';
import _imports_1 from '@/assets/images/common-icon/table-control-up.svg';
import _imports_2 from '@/assets/images/common-icon/table-control-down.svg';
const _withScopeId = n => (_pushScopeId("data-v-548a942c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-key"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  key: 0,
  class: "controlBox"
};
const _hoisted_5 = {
  class: "controlBox-list"
};
const _hoisted_6 = ["onUpdate:modelValue"];
const _hoisted_7 = {
  class: "item-icon"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "controlBox-button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_VueDraggable = _resolveComponent("VueDraggable");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "controlIcon",
    onClick: _cache[0] || (_cache[0] = $event => ($setup.getFieldSortList(), _ctx.isShowControlBox = !_ctx.isShowControlBox))
  }, _hoisted_3), _ctx.isShowControlBox ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_VueDraggable, {
    ref: "drag",
    modelValue: _ctx.fieldSortList,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.fieldSortList = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldSortList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "controlBox-list-item",
        key: index
      }, [_createVNode(_component_el_switch, {
        modelValue: item.is_choose,
        "onUpdate:modelValue": $event => item.is_choose = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createTextVNode(" " + _toDisplayString(item.name) + " ", 1), _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": $event => item.width = $event,
        style: {
          "width": "50px"
        }
      }, null, 8, _hoisted_6), [[_vModelText, item.width]]), _createElementVNode("div", _hoisted_7, [index != 0 ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _imports_1,
        alt: "",
        onClick: $event => $setup.riseSort(item, index)
      }, null, 8, _hoisted_8)) : _createCommentVNode("", true), index != _ctx.fieldSortList.length - 1 ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _imports_2,
        alt: "",
        onClick: $event => $setup.descendSort(item, index)
      }, null, 8, _hoisted_9)) : _createCommentVNode("", true)])]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: "controlBox-button-save",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.handleSaveField && $setup.handleSaveField(...args))
  }, _toDisplayString(_ctx.$t('other.save')), 1), _createElementVNode("div", {
    class: "controlBox-button-reset",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.handelResetField && $setup.handelResetField(...args))
  }, _toDisplayString(_ctx.$t('other.reset')), 1)])])) : _createCommentVNode("", true)]);
}